
<h2>TERMS OF USE</h2>


<a name="intro"></a>
<h3>Introduction</h3>
<app-intro></app-intro>
<a name="general"></a>
<h3>General</h3>
<app-general></app-general>
<a name="membership"></a>
<h3>Membership</h3>
<app-membership></app-membership>
<a name="open-free-access"></a>
<h3>Open Free Service</h3>
<app-open-free-access></app-open-free-access>
<a name="billing"></a>
<h3>Billing</h3>
<app-billing></app-billing>
<a name="password-account"></a>
<h3>Passwords and Account Access</h3>
<app-passwords-account-access></app-passwords-account-access>
<a name="dw-company"></a>
<h3>Information Team</h3>

Boldungu services are provided by a team of volunteers under the leadership of Prof. Benjamin Kanagwa, at the Schoool of Computing and Informatics Technology, Mekerere University,Kampala, Uganda

<a name="warranties"></a>
<h3>Subscriber Warranties, Rights, Representations, Restrictions, and Obligations</h3>
<app-warranties></app-warranties>
<a name="availability-of-site"></a>
<h3>Availability of Website</h3>
<app-availability-of-site></app-availability-of-site>
<a name="third-party-sites"></a>
<h3>Third Party Links or Information</h3>
<app-third-party-links></app-third-party-links>
<a name="disclaimer-warrantee"></a>
<h3>Disclaimers of statements/Warranties</h3>
<app-disclaimer></app-disclaimer>
<a name="limited-liability"></a>
<h3>Limitation of Liability</h3>
<app-limited-liability></app-limited-liability>
<a name="indemnify"></a>
<h3>Indemnity</h3>
<app-indemnify></app-indemnify>
<a name="survival"></a>
<h3>Survival</h3>
<app-survival></app-survival>
<a name="changes"></a>
<h3>Changes</h3>
<app-changes></app-changes>
<a name="assignment"></a>
<h3>Assignment</h3>
<app-assignment></app-assignment>
<a name="injuction"></a>
<h3>Injunction</h3>
<app-injunction></app-injunction>
<a name="severability"></a>
<h3>Severabilty</h3>
<app-severability></app-severability>
<a name="complete-understanding"></a>
<h3>Complete Understanding</h3>
<app-complete-understanding></app-complete-understanding>
<a name="any-questions"></a>
<h3>Any Questions</h3>
<a routerLink="static/display/about/us">Contact Us</a>
